/* GTL4Life spin wheel (09_apps/kolelo, README there).
   Owner 01.11: „клиента въвежда имейла, вижда анимацийка колелото се завърта … честито ти спечели … кода и копирай бутон
   и продължи“, „махни рекапчата“. The prize is drawn here by the weights from the section settings; the wheel spins at
   once and shows the code. The e-mail and prize go to our hooks server (data-hook, mpkit.kolelo; no Shopify form, so no
   captcha), which makes the subscribed Shopify customer with tags newsletter,kolelo,kolelo-<prize> within minutes.
   A send that fails is kept and sent again on the next page. ?kolelo=1 opens it at once (for tests). */
(() => {
  if (customElements.get('gtl-kolelo')) return;

  const DONE = 'gtlKoleloDone', SEEN = 'gtlKoleloSeen', UNSENT = 'gtlKoleloUnsent';
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
    del(k) { try { localStorage.removeItem(k); } catch (e) { /* private mode */ } }
  };
  const KEYS = ['5', '10', '15', 'gift'];                    // same order as data-weights
  const LABEL = { '5': '−5%', '10': '−10%', '15': '−15%', gift: 'Подарък' };
  // slices clockwise from the top; −10% repeats because it is the common prize
  const SLICES = ['10', '5', '10', '15', '10', 'gift', '10', '5'];
  const COLORS = { '10': ['#1F3FAE', '#FFFFFF'], '5': ['#FDC702', '#0F1226'], '15': ['#0F1226', '#FDC702'], gift: ['#FFFFFF', '#1F3FAE'] };
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  class GtlKolelo extends HTMLElement {
    connectedCallback() {
      this.weights = (this.dataset.weights || '10,80,5,5').split(',').map((n) => Math.max(0, parseFloat(n) || 0));
      this.codes = (this.dataset.codes || '').split(',');
      this.wheel = this.querySelector('.gtlk__wheel');
      this.dialog = this.querySelector('.gtlk__dialog');
      this.draw();
      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.onDocKey = (e) => this.onKey(e);
      this.querySelector('.gtlk__form').addEventListener('submit', (e) => { e.preventDefault(); this.spin(); });
      this.querySelector('[data-copy]').addEventListener('click', (e) => this.copy(e.currentTarget));
      this.querySelector('[data-continue]').addEventListener('click', () => this.proceed());
      this.resend();
      if (/[?&]kolelo=1(&|$)/.test(location.search) || this.hasAttribute('data-design-mode')) { this.open(true); return; }
      if (this.allowed()) this.arm();
    }

    allowed() {
      if (store.get(DONE)) return false;
      const seen = parseInt(store.get(SEEN) || '0', 10);
      if (seen && Date.now() - seen < (parseFloat(this.dataset.days) || 30) * 864e5) return false;
      return !/^\/(cart|checkout|account|challenge)/.test(location.pathname);
    }

    arm() {
      const fire = () => this.open();
      this.timer = setTimeout(fire, (parseFloat(this.dataset.delay) || 30) * 1000);
      const share = (parseFloat(this.dataset.scroll) || 50) / 100;
      this.onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= share) fire();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.onLeave = (e) => { if (!e.relatedTarget && e.clientY <= 0) fire(); };
        document.addEventListener('mouseout', this.onLeave);
      } else {
        // Leaving on a phone (owner 01.11: „при напускане на страницата“): no mouse leaves the window, so a quick swipe
        // back up toward the address bar (200 px in under half a second, after reading down at least 300 px) counts
        let top = window.scrollY, topAt = performance.now(), deepest = window.scrollY;
        this.onFlick = () => {
          const y = window.scrollY, now = performance.now();
          if (y >= top || now - topAt > 500) { top = y; topAt = now; }   // going down or slow: start a new upward run
          deepest = Math.max(deepest, y);
          if (deepest >= 300 && top - y >= 200) fire();
        };
        window.addEventListener('scroll', this.onFlick, { passive: true });
      }
      // Leaving to another tab or app and coming back
      this.onVisible = () => { if (document.visibilityState === 'hidden') this.away = true; else if (this.away) fire(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }

    disarm() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
      if (this.onFlick) window.removeEventListener('scroll', this.onFlick);
      if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
    }

    open(force) {
      if (this.isOpen) return;
      if (!force && document.querySelector('sendica-popup')) {   // the order form is open: try again later
        clearTimeout(this.retry);
        this.retry = setTimeout(() => this.open(), 5000);
        return;
      }
      this.disarm();
      this.isOpen = true;
      this.hidden = false;
      document.documentElement.classList.add('gtlk-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      if (!store.get(DONE)) store.set(SEEN, String(Date.now()));
      this.lastFocus = document.activeElement;
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        setTimeout(() => {
          const input = this.querySelector('#GtlkEmail');
          if (input && !this.querySelector('[data-step="form"]').hidden) input.focus({ preventScroll: true });
        }, 60);
      }
      this.watch = new MutationObserver(() => { if (document.querySelector('sendica-popup')) this.close(); });
      this.watch.observe(document.body, { childList: true });
      document.addEventListener('keydown', this.onDocKey);
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('gtlk-lock');
      if (this.watch) this.watch.disconnect();
      document.removeEventListener('keydown', this.onDocKey);
      setTimeout(() => { if (!this.isOpen) this.hidden = true; }, 260);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    onKey(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'Tab') return;
      const items = [...this.dialog.querySelectorAll('button, input')].filter((el) => el.offsetParent !== null && !el.disabled);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    draw() {
      const n = SLICES.length, r = 100;
      let svg = '<circle r="106" fill="#FDC702"/><circle r="101" fill="#0F1226"/>';
      SLICES.forEach((key, i) => {
        const a0 = (i / n) * 2 * Math.PI - Math.PI / 2, a1 = ((i + 1) / n) * 2 * Math.PI - Math.PI / 2;
        const [bg, fg] = COLORS[key];
        const mid = (i + 0.5) * (360 / n);
        svg += `<path d="M0 0L${(r * Math.cos(a0)).toFixed(2)} ${(r * Math.sin(a0)).toFixed(2)}A${r} ${r} 0 0 1 ${(r * Math.cos(a1)).toFixed(2)} ${(r * Math.sin(a1)).toFixed(2)}Z" fill="${bg}" stroke="#0F1226" stroke-width="1.2"/>`;
        const turn = mid > 180 ? `rotate(${mid + 90}) translate(-60 0)` : `rotate(${mid - 90}) translate(60 0)`;   // labels stay upright
        svg += `<text transform="${turn}" fill="${fg}" font-size="${key === 'gift' ? 13 : 16}" text-anchor="middle" dominant-baseline="central">${LABEL[key]}</text>`;
      });
      for (let i = 0; i < n; i++) {
        const a = (i / n) * 2 * Math.PI - Math.PI / 2;
        svg += `<circle cx="${(103.5 * Math.cos(a)).toFixed(2)}" cy="${(103.5 * Math.sin(a)).toFixed(2)}" r="2.2" fill="#FFFFFF"/>`;
      }
      this.wheel.innerHTML = svg;
    }

    rand() {
      try { const a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] / 4294967296; } catch (e) { return Math.random(); }
    }

    pick() {
      const total = this.weights.reduce((a, b) => a + b, 0) || 1;
      let x = this.rand() * total;
      for (let j = 0; j < KEYS.length; j++) { x -= this.weights[j]; if (x < 0) return KEYS[j]; }
      return '10';
    }

    async spin() {
      if (this.busy) return;
      const input = this.querySelector('#GtlkEmail'), error = this.querySelector('.gtlk__error');
      const email = input.value.trim();
      if (!EMAIL.test(email)) { error.hidden = false; input.focus(); return; }
      error.hidden = true;
      this.busy = true;
      // close the phone keyboard and bring the wheel back into view before anything moves
      input.blur();
      const dialog = this.querySelector('.gtlk__dialog');
      if (dialog && dialog.scrollTo) dialog.scrollTo({ top: 0 });
      const button = this.querySelector('.gtlk__form .gtlk__button');
      button.disabled = true;
      button.textContent = 'Върти се…';
      const prize = this.pick();
      this.send({ email, prize });   // in the background: the spin does not wait for it
      await this.rotateTo(prize);
      this.finish(prize);
    }

    // To our hooks server as a simple CORS request (text/plain, no preflight); keepalive lets it finish if the page changes.
    // Not sent (offline, server down): kept in this browser and sent again on the next page.
    async send(signup) {
      store.set(UNSENT, JSON.stringify(signup));
      try {
        const res = await fetch(this.dataset.hook, { method: 'POST', mode: 'cors', keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(signup) });
        if (res.ok || res.status === 400) store.del(UNSENT);   // 400 = refused for good (not a valid signup): no retry
      } catch (err) { /* stays in UNSENT */ }
    }

    resend() {
      try {
        const signup = JSON.parse(store.get(UNSENT) || 'null');
        if (signup && signup.email && signup.prize) this.send(signup);
      } catch (err) { store.del(UNSENT); }
    }

    rotateTo(prize) {
      const slots = SLICES.map((k, i) => (k === prize ? i : -1)).filter((i) => i >= 0);
      const i = slots[Math.floor(this.rand() * slots.length)];
      const seg = 360 / SLICES.length;
      const target = 360 * 6 + (360 - (i + 0.5) * seg) + (this.rand() - 0.5) * seg * 0.6;
      return new Promise((resolve) => {
        let ended = false;
        const end = () => { if (!ended) { ended = true; resolve(); } };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.wheel.style.transition = 'none';
          this.wheel.style.transform = `rotate(${target % 360}deg)`;
          setTimeout(end, 400);
          return;
        }
        this.wheel.style.transition = 'transform 4.6s cubic-bezier(.12,.72,.16,1)';
        requestAnimationFrame(() => { this.wheel.style.transform = `rotate(${target}deg)`; });
        this.wheel.addEventListener('transitionend', end, { once: true });
        setTimeout(end, 5300);
      });
    }

    finish(prize) {
      store.set(DONE, String(Date.now()));
      this.disarm();
      const code = this.codes[KEYS.indexOf(prize)] || '';
      this.querySelector('[data-win-title]').textContent = prize === 'gift' ? 'Печелиш подарък' : `Печелиш ${LABEL[prize]} отстъпка`;
      this.querySelector('[data-win-text]').textContent = prize === 'gift'
        ? 'Пакет лепенки за уста безплатно към поръчка с Deep Sleep, лепенки за нос или комплекта.'
        : `${LABEL[prize]} за цялата ти поръчка.`;
      this.querySelector('[data-win-code]').textContent = code;
      this.code = code;
      this.show('win');
    }

    // „Продължи“: the code goes into the cart (Shopify's /discount/<code> sets it, as the e-mail buttons do), then it closes
    async proceed() {
      const button = this.querySelector('[data-continue]');
      button.disabled = true;
      if (this.code) {
        try { await fetch(`/discount/${encodeURIComponent(this.code)}`, { credentials: 'same-origin' }); } catch (err) { /* the code is on screen */ }
      }
      this.close();
    }

    show(step) {
      this.querySelectorAll('.gtlk__panel').forEach((panel) => { panel.hidden = panel.dataset.step !== step; });
      const target = this.querySelector(`[data-step="${step}"] .gtlk__button, [data-step="${step}"] [data-copy]`);
      if (target && window.matchMedia('(hover: hover) and (pointer: fine)').matches) target.focus({ preventScroll: true });
    }

    copy(button) {
      const code = this.querySelector('[data-win-code]');
      const done = () => { button.textContent = 'Копирано'; };
      const select = () => { const range = document.createRange(); range.selectNodeContents(code); const s = getSelection(); s.removeAllRanges(); s.addRange(range); };
      try {
        navigator.clipboard.writeText(code.textContent).then(done, select);
      } catch (e) {
        select();
      }
    }
  }

  customElements.define('gtl-kolelo', GtlKolelo);
})();
